import { audiencerateApi } from '@/services/audiencerate';
import { GetWorkspaceMetricsArgs, WorkspaceMetricsResponse } from './types';

export const metricsApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkspaceMetrics: build.query<WorkspaceMetricsResponse, GetWorkspaceMetricsArgs>({
      query: ({ workspaceId }) => ({
        url: `/v1/workspaces/${workspaceId}/metrics`,
      }),
      providesTags: ['WorkspaceMetrics'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWorkspaceMetricsQuery } = metricsApi;
